import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 20px auto;
  align-items: center;
  height: 100%;
  max-width: 370px;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 10px;
    padding: 20px;
  }
`